module.exports = __webpack_public_path__ + "img/case16-jpg.7a9042cc.jpg";